export default __webpack_public_path__ + "static/media/portfolio_thumb.76dbaf20.png";